import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1521232846418034';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // 1. Inject Meta Pixel base script (only once)
    if (!window.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_ID);
    }
    // 2. PageView (al cargar la página)
    window.fbq('track', 'PageView');
    // 3. ViewContent (vista de sales page = contenido visto)
    window.fbq('track', 'ViewContent', {
      content_name: 'Sales Page - MyCodeex',
      content_category: 'Landing',
      content_type: 'product'
    });
    // 4. Global click listener: cualquier click en CTA dispara "Lead" + "InitiateCheckout"
    const ctaKeywords = ['start', 'empezar', 'try', 'probar', 'get', 'sign up', 'registr', 'comenzar', 'decode', 'free', 'gratis', 'launch', 'app', 'now', 'ya', 'descifra', 'empieza'];
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const el = target.closest('a, button') as HTMLElement | null;
      if (!el) return;
      const text = (el.innerText || el.textContent || '').toLowerCase();
      const isCTA = ctaKeywords.some(k => text.includes(k));
      if (!isCTA) return;
      window.fbq('track', 'Lead', {
        content_name: 'Sales Page CTA Click',
        content_category: 'Landing',
        value: 0,
        currency: 'USD'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Sales Page → App',
        value: 0,
        currency: 'USD'
      });
    };
    document.body.addEventListener('click', handleClick);
    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);
  return <noscript data-id="element-66">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-67" />
    </noscript>;
}